import config from './config'

import {signUpAxios} from './axios'

import http from '../../util/http'

export default http(signUpAxios,config.api)